import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import moment from 'moment';
import Loader from "../CommonLoader";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { AppContext } from "../../../Context/Context";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorGWT from "./ErrorGWT";
import { Helmet } from 'react-helmet';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from "react-router-dom";
import { Commonfun } from './../Commonfun';
import { Utils } from "../../../Utils/Utils";
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import { Breadcrumbs, Card, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import WarningCount from "../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Commoncard from "../Commoncard";
import ScoreGauge from "../../../Components/chart/gaugeChart";



ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    title="Select a Start Date"
    readOnly
    style={{ cursor: "pointer" }}
  />
));
const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    title="Select a End Date"
    readOnly
    style={{ cursor: "pointer" }}
  />
));
const TopPerformingPages = () => {

  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [buttnval, setMenubutval] = useState('brand')
  const SevenDaysBefore = moment().subtract(7, 'd').toDate();
  const [startDate, setStartDate] = useState(SevenDaysBefore);
  const [EndDate, SetEndDate] = useState(new Date());
  const [cardData, setCardData] = useState([]);
  const rows = cardData ?? [];
  const [loading, setLoading] = useState(false);
  const [ShowMainAlert, SetShowMainAlert] = useState(true)
  const [TableErrorMessage, SetTableErrorMessage] = useState('')
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [freesiteaudit, setfreesiteaudit] = useState({ status: false, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });
  const [summaryData, setSummaryData] = useState({
    "efficiency_score": 0,
    "visibility_funnel": {
      "Page 1 (Visible)": 0,
      "Striking Distance (11-20)": 0,
      "Deep Rank (21+)": 0
    },
    "summary": {
      "total_pages_ranked": 0,
      "avg_market_position": 0
    },
    "top_5_winners": [],
    "top_5_optimization_gaps": []
  });


  const navigate = useNavigate();

  function roundToTwoDecimalPlaces(number) {
    return parseFloat(number.toFixed(2));
  }
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const columns = [


    {
      field: "page_url",
      headerName: "Page URL",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      description: "Top performing web page URLs",
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        return (
          <>
            <div className="table-link-url">
              <span className="spanlink">
                <LinkIcon />
              </span>
              <a className="table_links" target="_blank" href={cardData.row.page_url}>{cardData.row.page_url}</a>
            </div>
          </>
        );

      }
    },
    {
      field: "impressions",
      headerName: "Impressions",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "It is counted each time your ad or webpage link is shown on a search result page",
    },
    {
      field: "clicks",
      headerName: "Clicks",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "Every click by the viewer on the website available in organic search results is counted as a click.",
    },
    {
      field: "ctr",
      headerName: "CTR %",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: true,
      description: "It means number of clicks that your website receives divided by the number of impressions your website is shown (clicks/impression).",
      renderCell: (cardData) => {

        var RoundedVal = 0;
        RoundedVal = roundToTwoDecimalPlaces(cardData.row.ctr)
        return (
          <>{RoundedVal}%</>
        )

      }

    },
    {
      field: "position",
      headerName: "Average Position",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: true,
      description: "Average position (ranking) of the keywords that was added to the campaign through campaign settings.",
      renderCell: (cardData) => {

        var RoundedVal = 0;
        RoundedVal = roundToTwoDecimalPlaces(cardData.row.position)
        return (
          <>{RoundedVal}</>
        )

      }

    },
  ];

  const GetAPIData = async (type = '') => {
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    SetShowMainAlert(false)
    SetTableErrorMessage('')
    SetTotalImpressions(0)
    SetTotalClicks(0)
    SetAverageCTR(0)
    SetAverageRank(0)
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}googleanalytics/v2/topperformingpages/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data?.top_performing_pages) {
        if (datavalue?.data?.top_performing_pages) {
          if (datavalue?.data.top_performing_pages.length > 0) {
            const newData = datavalue.data.top_performing_pages.map((obj, index) => {
              return { ...obj, sid: index + 1 };
            });
            setCardData(newData);
            SetAutoheightval(false)
          }
          else {
            var ErrorMessage;
            ErrorMessage = 'Data Not Available For This date Range'
            SetTableErrorMessage(ErrorMessage)
            SetAutoheightval(true)
          }
        }
      }
      if (datavalue?.data?.status_code) {
        SetShowMainAlert(true)
      }

      if (datavalue?.data) {
        setSummaryData({
          "efficiency_score": datavalue?.data?.charts?.efficiency_score || 0,
          "visibility_funnel": {
            "Page 1 (Visible)": datavalue?.data?.charts?.visibility_funnel["Page 1 (Visible)"] || 0,
            "Striking Distance (11-20)": datavalue?.data?.charts?.visibility_funnel["Striking Distance (11-20)"] || 0,
            "Deep Rank (21+)": datavalue?.data?.charts?.visibility_funnel["Deep Rank (21+)"] || 0
          },
          "summary": {
            "total_pages_ranked": datavalue?.data?.charts?.summary?.total_pages_ranked || 0,
            "avg_market_position": datavalue?.data?.charts?.summary?.avg_market_position || 0
          },
          "top_5_winners": datavalue?.data?.charts?.top_5_winners || [],
          "top_5_optimization_gaps": datavalue?.data?.charts?.top_5_optimization_gaps || []
        })
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data) {
          SetTableErrorMessage(err.response.data.error)
        }
        else {
          SetTableErrorMessage('')
        }
      }
      else {
        SetTableErrorMessage('')
      }
    }
    setTableLoading(false);
    setLoading(false);
  }

  const [BrandPercentage, SetBrandPercentage] = useState(0)
  const [BrandLabel, SetBrandLabel] = useState('')
  const [NonBrandPercentage, SetNonBrandPercentage] = useState(0)
  const [NonBrandLabel, SetNonBrandLabel] = useState('')
  const [ChartType, SetChartType] = useState('impressions')
  const [TotalImpressions, SetTotalImpressions] = useState(0)
  const [TotalClicks, SetTotalClicks] = useState(0)
  const [AverageCTR, SetAverageCTR] = useState(0)
  const [AverageRank, SetAverageRank] = useState(0)
  const data = [
    { value: BrandPercentage, label: BrandLabel },
    { value: NonBrandPercentage, label: NonBrandLabel },

  ];

  const [ClicksSeries, SetClicksSeries] = useState([])
  const [ImpressionSeries, SetImpressionSeries] = useState([])
  const [SeriesDate, SetSeriesDate] = useState([])

  const GetGraphdata = async (type = '') => {

    setLoading(true)
    SetSeriesDate([])
    SetClicksSeries([])
    SetImpressionSeries([])

    SetBrandPercentage(0)
    SetNonBrandPercentage(0)


    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')

    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}googleanalytics/v2/topperformingpages/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&page=chart`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      setLoading(false)

      if (datavalue?.data) {
        setSummaryData({
          "efficiency_score": datavalue?.data?.charts?.efficiency_score || 0,
          "visibility_funnel": {
            "Page 1 (Visible)": datavalue?.data?.charts?.visibility_funnel["Page 1 (Visible)"] || 0,
            "Striking Distance (11-20)": datavalue?.data?.charts?.visibility_funnel["Striking Distance (11-20)"] || 0,
            "Deep Rank (21+)": datavalue?.data?.charts?.visibility_funnel["Deep Rank (21+)"] || 0
          },
          "summary": {
            "total_pages_ranked": datavalue?.data?.charts?.summary?.total_pages_ranked || 0,
            "avg_market_position": datavalue?.data?.charts?.summary?.avg_market_position || 0
          },
          "top_5_winners": datavalue?.data?.charts?.top_5_winners || [],
          "top_5_optimization_gaps": datavalue?.data?.charts?.top_5_optimization_gaps || []
        })
        if (datavalue?.data?.chart_data) {
          const datesArray = datavalue.data.chart_data.map(item => item.date);
          const clicksArray = datavalue.data.chart_data.map(item => item.clicks);
          const impressionsArray = datavalue.data.chart_data.map(item => item.impressions);
          SetSeriesDate(datesArray)
          SetClicksSeries(clicksArray)
          SetImpressionSeries(impressionsArray)
        }
      }

    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    GetAPIData('brand')
    GetGraphdata('impressions')
    faqdatafun()
    GetuserDatavalue();
  }, [])

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }

      });
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };

  const SubmitData = () => {
    GetAPIData(buttnval)
    GetGraphdata(ChartType)
  }

  const chartData = {
    labels: SeriesDate,
    datasets: [
      {
        label: 'Impressions',
        data: ImpressionSeries,
        fill: false,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        tension: 0.1,
      },
      {
        label: 'Clicks',
        data: ClicksSeries,
        fill: false,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgba(255, 99, 132, 1)',
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || '';
            const date = new Date(context.parsed.x);
            const formattedDate = date.toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            });
            const value = context.parsed.y;
            return `${label}: ${value} on ${formattedDate}`;
          },
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          tooltipFormat: 'MMM dd, yyyy',
        },
        title: {
          display: true,
          text: 'Date',
          font: { size: 12 },
          padding: 10,
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 7,
          maxRotation: 0,
          minRotation: 0,
          callback: function (value, index, values) {
            return new Date(values[index].value).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            });
          },
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Values',
          font: { size: 12 },
        },
        beginAtZero: true,
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
  };
  const pdfdown = async () => {
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}googleanalytics/v2/topperformingpages/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&formats=pdf`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("TopPerformingpage", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);

  }
  const csvdown = async () => {
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}googleanalytics/v2/topperformingpages/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&formats=csv`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("TopPerformingpage", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=39`
    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const freeAudit = async () => {
    const check = await Utils("top_performing_pages", ApiToken);
    setfreesiteaudit(check);
  }

  useEffect(() => {
    freeAudit();
  }, [buttnval])

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
    transition: "background 0.2s",
  };

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={summaryData.efficiency_score} width={'120px'} />
      </div>
    )
  }

  const cardDatas = [
    {
      value: summaryData.summary.avg_market_position || 0,
      title: "Average Market Position",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.summary.total_pages_ranked || 0,
      title: "Total Pages Ranked",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    }
  ];

  const urls1 = Array.isArray(summaryData?.top_5_winners)
    ? summaryData.top_5_winners
    : [];
  const urls2 = Array.isArray(summaryData?.top_5_optimization_gaps)
    ? summaryData.top_5_optimization_gaps
    : [];

  const chartOptions = (urls) => {

    return {
      chart: {
        type: "bar",
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true, // better for long URLs
          barHeight: "80%"
        }
      },
      xaxis: {
        categories: urls?.map(item =>
          item.page_url.length > 40 ? item.page_url.slice(0, 40) + "..." : item.page_url
        ) || [],
        labels: {
          show: false   // 👈 hides numbers/text on x-axis
        },
        axisBorder: {
          show: false   // optional: remove axis line
        },
        axisTicks: {
          show: false   // optional: remove ticks
        }
      },
      yaxis: {
        labels: {
          maxWidth: 150
        }
      },
      grid: {
        padding: {
          left: 20,
          right: 20
        }
      },
      tooltip: {
        x: {
          formatter: (val, opts) => urls[opts.dataPointIndex]?.page_url
        },
        y: {
          formatter: (val) => val
        }
      }
    };
  }

  const chartSeries = (urls) => {

    return [
      {
        name: "Impressions",
        data: urls?.map(item => item.impressions) || []
      },
      {
        name: "CTR",
        data: urls?.map(item => item.ctr) || []
      },
      {
        name: "Clicks",
        data: urls?.map(item => item.clicks) || []
      },
      {
        name: "Position",
        data: urls?.map(item => item.position) || []
      }
    ];
  }

  return (
    <div className={`over_all_container brand_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Top Performing Pages</title>
      </Helmet>
      {
        loading === true ? <Loader /> : null
      }

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Top Performing Pages
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Google Analytics' },
                      { title: 'Top Performing Pages', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                {freesiteaudit.status && <div className="wrap_trans_back">
                  <div className="daterangepicker_wrap">
                    <DatePicker selected={startDate} onChange={first.statusDomain ? () => setcheckD(first.statusDomain) : (date) => setStartDate(date)} placeholderText="Start Date"
                      customInput={<CustomInput />} />
                    <DatePicker selected={EndDate} onChange={first.statusDomain ? () => setcheckD(first.statusDomain) : (date) => SetEndDate(date)} placeholderText="End Date" customInput={<CustomInput1 />} />
                    <button className="btn_dashboard" onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : () => SubmitData()}>Submit</button>
                  </div>
                </div>}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          {
            ShowMainAlert === true && freesiteaudit.status ?

              <ErrorGWT /> : null
          }

          {(SeriesDate.length > 0 && ShowMainAlert === false && freesiteaudit.status) &&
            <>
              <Grid container spacing={3} xs={12} sm={12} md={4} justifyContent="center" style={{ paddingLeft: "20px" }}>
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={12} md={12} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} sm={12} md={12}>
                  <Card
                    sx={{
                      borderRadius: "16px",
                      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                      transition: "0.3s",
                      cursor: "default",
                      height: "100%",
                      // border: 1px solid #e0e0e0;
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                      },
                      overflow: "hidden",
                      border: "none"
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#d1fae5',
                        p: 2.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 700,
                          fontSize: "2.5rem",
                          background: "linear-gradient(to right, #1f2937, #4b5563)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                          letterSpacing: 1,
                        }}
                      >
                        <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{summaryData.efficiency_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                      </Typography>
                      <Box
                        sx={{
                          // backgroundColor: '#7c3aed',
                          color: "#059669",
                          // p: 1.5,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "1.5rem",
                        }}
                      >
                        {/* {icon} */}
                        {gaugeChart()}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        background: "#fff",
                        px: 2.5,
                        py: 3,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textTransform: "uppercase",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                      >
                        Health Score
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              </Grid>

              <Grid item xs={12} md={8}>
                <div className="">
                  {
                    (SeriesDate.length > 0 && ShowMainAlert === false && freesiteaudit.status) &&
                    <div className="google_area_chart_wrap">
                      <div className="site_regress_chart_info" style={{ margin: 'auto', width: "90%" }}>
                        <div className="site_Chart_info_inner" >
                          <div style={{ width: '100%', height: '400px', margin: '0 auto' }}>
                            <Line options={options} data={chartData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </Grid>
            </>
          }

          {(SeriesDate.length > 0 && ShowMainAlert === false && freesiteaudit.status) &&
            <>
              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '420px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Visibility Funnel</Typography>
                  <Chart
                    type="donut"
                    height={400}
                    series={Object.values(summaryData.visibility_funnel)}
                    options={{
                      labels: Object.keys(summaryData.visibility_funnel),
                      legend: { position: 'bottom', fontSize: '10px' },
                      dataLabels: { enabled: false }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '420px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>{"Top 5 Winners (Pages with the most click)"}</Typography>
                  <Chart
                    options={chartOptions(urls1)}
                    series={chartSeries(urls1)}
                    type="bar"
                    height={360}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box className="grid_table_shodow" style={{ padding: '15px', height: '420px' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>{"Top 5 Optimization Gaps (Pages with high impressions but zero clicks)"}</Typography>
                  <Chart
                    options={chartOptions(urls2)}
                    series={chartSeries(urls2)}
                    type="bar"
                    height={360}
                  />
                </Box>
              </Grid>
            </>
          }

        </Grid>
      </Container>

      {
        freesiteaudit.status && <div className="table_error_message">{TableErrorMessage}</div>
      }
      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {
                  (ShowMainAlert === false && cardData.length > 0) ? <>
                    {freesiteaudit.status && freesiteaudit.status ?

                      <DatagridComp
                        columns={columns}
                        rows={rows}
                        autoheightval={autoheightval}
                        datagridval={2}
                        columnFreezeWidth={[0]}
                        tableLoading={tableLoading}
                        handleDownlodingCSV={handleDownlodingCSV}
                        handleDownlodingPDF={handleDownlodingPDF}
                        customFilter={false}
                        DownloadShowFile={true}
                        DownloadShowPDF={1}
                        DownloadShowCSV={2}
                      /> : <Freeaudit planStatus={freesiteaudit} />} </>
                    : null
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>





      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

      {/* 
      <div className="cnt_audit_outer_wrap">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Google Analytics' },
            { title: 'Top Performing Pages', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />
            </button>
            {freesiteaudit.status && buttnval === "brand" &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font">Top Performing Pages</h2>
          </div>
          {freesiteaudit.status && <div className="wrap_trans_back">
            <div className="daterangepicker_wrap">
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Start Date"
                customInput={<CustomInput />} />
              <DatePicker selected={EndDate} onChange={(date) => SetEndDate(date)} placeholderText="End Date" customInput={<CustomInput1 />} />
              <button className="runreportnew" onClick={() => { SubmitData() }}>Submit</button>
            </div>
          </div>}
        </div>


        {
          (SeriesDate.length > 0 && ShowMainAlert === false && freesiteaudit.status) ? <div className="google_area_chart_wrap" style={{ marginTop: '30px' }}>
            <div className="site_regress_chart_info">
              <div className="site_Chart_info_inner" >
                <div style={{ width: '100%', height: '400px', margin: '0 auto' }}>
                  <Line options={options} data={chartData} />
                </div>
              </div>
            </div>
          </div> : null

        }
        {
          freesiteaudit.status && <div className="table_error_message">{TableErrorMessage}</div>
        }
        {
          (ShowMainAlert === false && cardData.length > 0) ? <>
            {freesiteaudit.status && freesiteaudit.status ? <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0]}
              tableLoading={tableLoading}
            /> : <Freeaudit planStatus={freesiteaudit} />} </>
            : null
        }
        {
          ShowMainAlert === true && freesiteaudit.status ?

            <ErrorGWT /> : null
        } 
      </div> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }

      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header"><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
              <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <UserActivityTracker pagename="Google Analytics - Top Performing Pages" />
    </div>
  )

}
export default TopPerformingPages